import React from "react";

import { Modal as AntdModal } from "antd";

import styled from "styled-components";
import { CustomModalProps, defaultButtonProps } from "../_types";
import ModalFooterLayout from "../ModalFooterLayout";
import { ReactComponent as ModalClose } from "../../../../assets/icons/ModalCloseBtn.svg";
import useModals from "../../../../hooks/useModals";
import ModalTitle from "../styles/ModalTitle";
import Button from "../../../atoms/Button";
import { MIN_MORNITOR_WIDTH } from "../../../constants";

const Modal: React.FC<CustomModalProps> = function Modal({
  children,
  onAdditional,
  onCancel,
  onOk,
  leftFooterElements,
  title,
  width,
  footer,
  customTitle,
  customFooter,
  okText,
  okButtonProps,
  okType,
  cancelText,
  cancelButtonProps,
  isCancelDanger,
  isNoFooter,
  isNotShowX,
  isOkDanger,
  isOkDisabled,
  isCancelDisabled,
  isOneBtn,
  justifyBody,
  alignBody,
  ...restProps
}) {
  const { resetModal } = useModals();
  return (
    <StyledModal
      {...restProps}
      centered
      customHeader={customTitle}
      title={customTitle || <ModalTitle>{title}</ModalTitle>}
      visible
      closeIcon={<ModalClose />}
      width={`${width}px` || "40vw"}
      maskClosable={false}
      onCancel={onCancel || resetModal}
      onOk={onOk}
      closable={!isNotShowX}
      justifyBody={justifyBody}
      alignBody={alignBody}
      okType={okType}
      okText={okText || "확인"}
      cancelText={cancelText || "취소"}
      cancelButtonProps={
        cancelButtonProps || {
          ...defaultButtonProps,
          danger: isCancelDanger || false,
          onClick: onAdditional || resetModal,
        }
      }
      okButtonProps={
        okButtonProps || {
          ...defaultButtonProps,
          danger: isOkDanger || false,
          onClick: onOk,
        }
      }
      customFooter={customFooter}
      footer={
        customFooter ||
        (isNoFooter ? null : (
          <ModalFooterLayout leftFooterElements={leftFooterElements}>
            {!isOneBtn && (
              <div style={{ marginRight: "8px" }}>
                <Button
                  size="large"
                  disabled={isCancelDanger}
                  onClick={onAdditional || onCancel}
                  ghost
                  type="default"
                  {...cancelButtonProps}
                >
                  {cancelText || "취소"}
                </Button>
              </div>
            )}
            <Button
              size="large"
              onClick={onOk}
              disabled={isOkDisabled}
              danger={isOkDanger}
              type="primary"
              {...okButtonProps}
            >
              {okText || "확인"}
            </Button>
          </ModalFooterLayout>
        ))
      }
    >
      <StyledModalBody>{children}</StyledModalBody>
    </StyledModal>
  );
};
export default Modal;

const StyledModalBody = styled.div`
  overflow-y: auto;
  max-height: calc(100vh - 228px);
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    max-height: calc(90vh);
  }
`;
const StyledModal = styled(AntdModal)<{
  justifyBody?: string;
  alignBody?: string;
  isNotShowX?: boolean;
  footer: React.ReactNode;
  customFooter: React.ReactNode;
  customHeader: React.ReactNode;
}>`
  border-radius: 8px;

  div.ant-modal-content {
    border-radius: 8px;

    box-sizing: border-box;
  }
  div.ant-modal-body {
    padding: 0;
    transition: height 1s;
  }
  div.ant-modal-header {
    display: flex;
    border-radius: 8px 8px 0 0;
    padding: 24px 32px;
  }
  span.ant-modal-close-x {
    width: 32px;
    height: 32px;
  }
  span.ant-modal-close-x span svg {
  }
  .ant-modal-title {
    width: 940px;
  }
  button.ant-modal-close {
    top: 24px;
    right: 32px;
  }
  div.ant-modal-footer {
    border-top: 1px solid #f0f0f0;
    padding: ${({ customFooter }) =>
      customFooter !== undefined ? "0px" : "24px"};
    border-radius: 0 0 8px 8px;
  }
`;
